<template>
    <v-content>
        <div>
            <v-breadcrumbs :items="breadcrumbItems" large></v-breadcrumbs>
            <div slot="table-actions">
                <div class="my-1">
                    <v-btn color="primary" @click.stop="addModal">{{$t('officeregistration')}} {{$t('form')}} </v-btn>


                </div>
            </div>
            <v-expansion-panels class="my-2">
                <v-expansion-panel>
                    <v-expansion-panel-header>{{ $t('table.filter') }} </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-container>
                            <v-row style="justify-content: center; z-index: 12;">
                                <v-col class="col-2" v-if="isSuperAdmin">
                                    <v-autocomplete :items="listDDLData.companyList"
                                                    @change="getDdlData(serverParams.companyID,'company')"
                                                    item-text="value"
                                                    item-value="id"
                                                    :label="$t('company')"
                                                    required dense outlined
                                                    v-model="serverParams.companyID">
                                    </v-autocomplete>
                                </v-col>
                                <v-col class="col-2" v-if="isSuperAdmin">
                                    <v-autocomplete :items="listDDLData.branchList"
                                                    @change="getDdlData(serverParams.companyID,'branch')"
                                                    item-text="value"
                                                    item-value="id"
                                                    :label="$t('branch')" dense outlined
                                                    v-model="serverParams.branchID"></v-autocomplete>
                                </v-col>
                                <v-col cols="2" v-if="isSuperAdmin">
                                    <v-autocomplete :items="listDDLData.depoList"
                                                    @change="getDdlData(formData.companyID,'depo')"
                                                    item-text="value"
                                                    item-value="id" dense outlined
                                                    :label="$t('depo')"
                                                    v-model="serverParams.depoID">
                                    </v-autocomplete>
                                </v-col>
                                <v-col class="col-2">
                                    <v-text-field :label="$t('email')"
                                                  dense outlined
                                                  v-model="serverParams.email"></v-text-field>
                                </v-col>
                                <v-col class="col-2">
                                    <v-text-field :label="$t('phonenumber')"
                                                  dense outlined
                                                  v-model="serverParams.phoneNumber"></v-text-field>
                                </v-col>
                                <v-col class="col-2">
                                    <v-text-field :label="$t('table.address')"
                                                  dense outlined
                                                  v-model="serverParams.address"></v-text-field>
                                </v-col>

                            </v-row>
                            <v-row align="center" justify="center">
                                <v-btn color="primary" dark @click="loadItems">
                                    <i class="material-icons">search</i>{{$t('search')}}
                                </v-btn>
                            </v-row>
                        </v-container>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <vue-good-table :columns="columns"
                            :rows="rows"
                            mode="remote"
                            :totalRows="branchData.totalRecords"
                            :pagination-options="{ enabled: true,mode: 'records' }"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            styleClass="vgt-table condensed"
                            max-height="600px"
                            :fixed-header="true">
                <template slot="table-column" slot-scope="props">
                    <span>
                        {{ $t(props.column.label) }}
                    </span>
                </template>
                <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'establishedYear'">
                        <span>{{props.row.establishedYear | moment("DD-MMM-YYYY, h:mm:ss a")}}</span>
                    </span>
                    <span v-else-if="props.column.field == 'actions'">
                        <v-icon dense class="mr-2" @click.stop="editItem(props.row)" style="color:dodgerblue">edit</v-icon>
                        <v-icon dense @click="deleteItem(props.row)" style="color:red">delete</v-icon>
                    </span>
                </template>
            </vue-good-table>
            <v-dialog v-model="snackbar.formModal"
                      max-width="800"
                      transition="dialog-bottom-transition"
                      persistent>
                <v-card>
                    <DepoForm @dialogueClose="dialogueClose"
                              @formResponse="formResponse"
                              v-if="snackbar.createFormComponent"></DepoForm>
                    <DepoEditForm @dialogueClose="dialogueClose"
                                  @formResponse="formResponse"
                                  v-if="snackbar.editFormComponent"
                                  :editItemIndex="branchData.editItemIndex"
                                  :editItemofficeType="branchData.editItemofficeType"></DepoEditForm>
                </v-card>
            </v-dialog>
            <v-snackbar v-model="snackbar.snackbar"
                        :color="snackbar.color"
                        :timeout="snackbar.timeout"
                        top>
                {{ snackbar.text }}
                <v-btn dark
                       text
                       @click="snackbar.snackbar = false">
                    Close
                </v-btn>
            </v-snackbar>
            <v-dialog v-model="snackbar.dialogDelete" max-width="500px">
                <deleteListOfficeData :deleteFormOfficeData="branchData.deleteFormOfficeData"
                                      @formResponse="onResponseDelete"></deleteListOfficeData>
            </v-dialog>
        </div>
    </v-content>
</template>

<script>
    import axios from "axios";
    import DepoForm from "./Form";
    import DepoEditForm from "./EditForm";
    /*import deleteListData from "@/components/deleteModal";*/
    import deleteListOfficeData from "@/components/deleteOfficeModal";
    import {mapGetters} from "vuex";

    export default {
        name: "DepoList",
        components: {
            'DepoForm': DepoForm,
            'DepoEditForm': DepoEditForm,
            //'deleteListData': deleteListData,
            'deleteListOfficeData': deleteListOfficeData
        },
     
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            branchPermission(){
                return this.isSuperAdmin || this.isCompany || this.isDepartment
            },
            isSuperAdmin() {
                return this.userRole === "SuperAdmin"
            },
            isCompany() {
                return this.userRole === "Company"
            },
            isDepartment() {
                return this.userRole === "Department"
            },
            breadcrumbItems() {
                return [
                    {
                        text: this.$t('officeRegistration'),
                        disabled: true,
                    },
                ]
            } 
        },
        data() {
            return {
                columns: [
                    {
                        label: 'name',
                        field: 'name',
                    },
                    {
                        label: 'code',
                        field: 'code',
                    },
                    {
                        label: 'officetype',
                        field: 'officeType',
                    },
                    {
                        label: 'address',
                        field: 'address',
                    },
                    {
                        label: 'phonenumber',
                        field: 'phoneNumber',
                    },
                    {
                        label: 'email',
                        field: 'email',
                    },
                    {
                        label: 'website',
                        field: 'website',
                    },
                    //{
                    //    label: 'Established Year',
                    //    field: 'establishedYear',
                    //},
                    {label: "actions", field: "actions"}
                ],
                rows: [],
                listDDLData: {
                    companyList: [],
                    departmentList: [],
                    branchList: [],
                    depoList: []
                },
                branchData: {
                    totalRows: 0,
                    editItemIndex: null,
                    editItemofficeType: null,
                    deleteFormData: {},
                    deleteFormOfficeData: {}
                },
                serverParams: {
                    branchID: 0,
                    companyID: 0,
                    departmentID: 0,
                    depoID: 0,
                    email: "",
                    phoneNumber: "",
                    address: "",
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "branchID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                snackbar: {
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    isLoading: false,
                    formModal: false,
                    createFormComponent: false,
                    editFormComponent: false,
                    dialogDelete: false,
                    
                    dynamicComponent: {
                        current: 'DepoForm'
                    }
                },
                employee: {
                    id:'/employee'
                }
                
            };
        },
        methods: {
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },

            onSortChange(params) {
              
                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            addModal() {
              
                this.snackbar.formModal = true
                this.snackbar.createFormComponent = true
            },
            addEmployee() {

            },
            editItem(item) {
                this.snackbar.formModal = true
                this.snackbar.editFormComponent = true
                if (item.officeTypeEN == 'Company') {
                    this.branchData.editItemIndex = item.companyID
                }
                if (item.officeTypeEN == 'Branch') {
                    this.branchData.editItemIndex = item.branchID
                }
                if (item.officeTypeEN == 'Depo') {
                    this.branchData.editItemIndex = item.depoID
                }
                this.branchData.editItemofficeType = item.officeTypeEN
            },
            deleteItem(item) {
                
                this.snackbar.dialogDelete = true;
                this.branchData.deleteFormOfficeData.url = "Depo/DeleteOffice";
                this.branchData.deleteFormOfficeData.item =  item;
               
                this.loadItems();
            },
            onResponseDelete() {
                this.snackbar.dialogDelete = false;
                this.loadItems();
            },
            formResponse(responseObj) {
                this.snackbar.color = responseObj.color ? responseObj.color : 'red'
                this.snackbar.text = responseObj.message ? responseObj.message : 'Server Error'
                this.snackbar.snackbar = true
                this.loadItems();
            },
            dialogueClose() {
                this.branchData.editItemIndex = null
                this.branchData.editItemofficeType = null
                this.snackbar.formModal = false
                this.snackbar.createFormComponent = false
                this.snackbar.editFormComponent = false
                this.loadItems()
            },
            async getData() {
                axios.get("Company/DDLCompanyList").then(response => {
                    this.listDDLData.companyList = response.data
                })
            },
            getDdlData(data, val) {
                let formVal = {}
                if (val == "company") {
                    this.listDDLData.branchList = []
                    this.listDDLData.depoList = []
                    this.listDDLData.departmentCompanyList = []
                    this.listDDLData.departmentBranchList = []
                    this.listDDLData.departmentDepoList = []
                    this.serverParams.branchID = null
                    this.serverParams.depoID = null
                    this.serverParams.departmentID = null
                    formVal = {
                        companyID: this.serverParams.companyID
                    }
                    axios.get("Branch/DDLBranchList", {
                        params: formVal
                    }).then(response => {
                        this.listDDLData.branchList = response.data
                    })

                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentCompanyList = response.data
                    })

                } else if (val == "branch") {
                    this.listDDLData.depoList = []
                    this.listDDLData.departmentBranchList = []
                    this.listDDLData.departmentDepoList = []
                    this.serverParams.depoID = null
                    this.serverParams.departmentID = null

                    formVal = {
                        branchID: this.serverParams.branchID
                    }
                    axios.get("Depo/DDLDepoList", {
                        params: formVal
                    }).then(response => {
                        this.listDDLData.depoList = response.data
                    })

                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentBranchList = response.data
                    })


                } else if (val == "depo") {
                    this.listDDLData.departmentDepoList = []
                    this.serverParams.departmentID = null

                    formVal = {
                        depoID: this.serverParams.depoID
                    }
                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentDepoList = response.data
                    })
                }

            },
            async loadItems() {
                this.snackbar.isLoading = true;
                let param = {
                    PageSize: this.serverParams.perPage == -1 ? this.branchData.totalRecords : this.serverParams.perPage,
                    PageNo: this.serverParams.page,
                    OrderType: this.serverParams.sort[0].type,
                    OrderBy: this.serverParams.sort[0].field,
                    branchID: this.serverParams.branchID == null ? 0 : parseInt(this.serverParams.branchID),
                    companyID: this.serverParams.companyID == null ? 0 : parseInt(this.serverParams.companyID),
                    depoID: this.serverParams.depoID == null ? 0 : parseInt(this.serverParams.depoID),
                    email: this.serverParams.email,
                    phoneNumber: this.serverParams.phoneNumber,
                    address: this.serverParams.address,
                    isActive : true
                };
                axios.post('Depo/List', param).then(response=>{
                    this.rows = response.data.list.data
                    this.branchData.totalRecords = response.data.list.totalCount
                    this.snackbar.loading = false;
                })
            },
        },
        mounted() {
            this.loadItems()
            this.getData()
        },

    }
</script>

<style scoped>

</style>
